// A module without imports: shared by publisherRegistrationApi and RegistrationConflictMessage, which sit on
// opposite ends of an import cycle (AltchaWidget -> stripes-core index -> PublisherRegistration).
/**
 * Why mod-br-publishers refused a registration with HTTP 409. The values are the publishers module's error types
 * (its ErrorType enum, numbered independently of the ErrorType of this package).
 */
export var RegistrationConflict;
(function (RegistrationConflict) {
    /** A publisher with the same IČO is already registered. */
    RegistrationConflict["COMPANY_NUMBER_ALREADY_EXISTS"] = "-5";
    /** A publisher with the same DIČ is already registered (RCK-1639). */
    RegistrationConflict["TAX_NUMBER_ALREADY_EXISTS"] = "-20";
    /** A natural person submitting a registration already on record (RCK-1639). */
    RegistrationConflict["REGISTRATION_ALREADY_SUBMITTED"] = "-21";
})(RegistrationConflict || (RegistrationConflict = {}));
